// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden[data-v-00fdb5c3] {\n    display: none;\n}\n.pageAlign[data-v-00fdb5c3] {\n    float: right;\n}\n.circle[data-v-00fdb5c3] {\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
